import React from 'react';
import PropTypes from 'prop-types';

const IconPowertrainGuideDrive = ({ width = 48, height = 48, color = '#000000' }) =>
    <svg width={width} height={height} viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M16.96 45.9404H2.95996L1.95996 44.9404V2.94043L2.95996 1.94043H16.96L17.96 2.94043V44.9404L16.96 45.9404ZM3.95996 43.9404H15.96V3.94043H3.95996V43.9404Z' fill={color} />
        <path d='M13.96 35.9404H5.95996V37.9404H13.96V35.9404Z' fill={color} />
        <path d='M13.96 31.9404H5.95996V33.9404H13.96V31.9404Z' fill={color} />
        <path d='M13.96 39.9404H5.95996V41.9404H13.96V39.9404Z' fill={color} />
        <path d='M8.95996 18.9404H6.95996V24.9404H8.95996V18.9404Z' fill={color} />
        <path d='M32.96 46.0004H20.96L19.96 45.0004V20.9404L20.96 19.9404H32.96L33.96 20.9404V45.0004L32.96 46.0004ZM21.96 43.9904H31.95V21.9404H21.96V43.9904Z' fill={color} />
        <path d='M26 31.0004L25.11 30.4604L24.07 28.4604L23.96 27.9904L24 24.9304L25.01 23.9404L29.01 24.0004L30 25.0004V28.0004L29.89 28.4504L28.89 30.4404L28 30.9904H26V31.0004ZM25.96 27.7704L26.6 29.0104H27.38L27.99 27.7804V26.0004L25.98 25.9704L25.96 27.7804V27.7704Z' fill={color} />
        <path d='M45.04 46.0604H37.04L36.04 45.0604V28.9404L37.04 27.9404H45.04L46.04 28.9404V45.0604L45.04 46.0604ZM38.04 44.0504H44.03V29.9404H38.04V44.0504Z' fill={color} />
        <path d='M41.96 31.9404H39.96V33.9404H41.96V31.9404Z' fill={color} />
    </svg>;

IconPowertrainGuideDrive.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default IconPowertrainGuideDrive;
